import { NonIdealState, NonIdealStateProps } from "@itwin/itwinui-react";

export const FullPageError = (
  props: NonIdealStateProps
) => {
  return <NonIdealState style={{ position: "unset", transform: "unset", height: "100%" }} {...props} />;
};
